import React from "react";

export default function Academics() {
	return (
		<main className="academics main-container">
			<div className="page-container">
				<h1>Academics</h1>
				<div className="section">
					<img alt="" src="/sean-eddy/images/old-main.jpg" />
					<div className="information">
						<h2>University of Arizona</h2>
						<h3>2021 - Present</h3>
						<h3>GPA: 3.90 (updated Spring 2024)</h3>
						<hr></hr>
						<ul>
							<li>M.S. Computer Science - Spring 2025</li>
							<li>B.S. Computer Science - Spring 2024</li>
						</ul>
						<hr></hr>
						<ul>
							<li>W.A. Franke Honors College</li>
							<li>Undergraduate Teaching Assistant</li>
						</ul>
					</div>
				</div>
				<div className="section">
					<img alt="" src="/sean-eddy/images/dmacc.jpg" />
					<div className="information">
						<h2>Des Moines Area Community College (DMACC)</h2>
						<h3>2018 - 2021</h3>
						<h3>GPA: 3.83</h3>
						<hr></hr>
						<ul>
							<li>Associate in Science - Spring 2021</li>
							<li>Associate in Arts - Spring 2021</li>
						</ul>
					</div>
				</div>
				<div className="section">
					<img alt="" src="/sean-eddy/images/valley.jpg" />
					<div className="information">
						<h2>Valley High School</h2>
						<h3>2018 - 2021</h3>
						<h3>GPA: 4.32/3.96</h3>
						<hr></hr>
						<ul>
							<li>High School Diploma (Honors)</li>
						</ul>
						<hr></hr>
						<ul>
							<li>Valley Honors Award</li>
							<li>AP Scholar with Distinction</li>
						</ul>
					</div>
				</div>
				<div className="section">
					<img alt="" src="/sean-eddy/images/code.jpg" />
					<div className="information">
						<h2>Programming Certificates</h2>
						<hr></hr>
						<ul>
							<li>
								<a
									href="https://www.codecademy.com/profiles/tikkisean/certificates/705dcb15de0da4dd9d9fc4f3274b430e"
									rel="noreferrer"
									target="_blank"
								>
									Learn JavaScript (Codecademy)
								</a>{" "}
								- Mar 2022
							</li>
							<li>
								<a
									href="https://www.codecademy.com/profiles/tikkisean/certificates/a549293c6e8d62a61ef1bec410b58162"
									rel="noreferrer"
									target="_blank"
								>
									Learn Kotlin (Codecademy)
								</a>{" "}
								- Feb 2022
							</li>
							<li>
								<a
									href="https://www.codecademy.com/profiles/tikkisean/certificates/5cadfefe5f1de806e9704577"
									rel="noreferrer"
									target="_blank"
								>
									Build a Website Skill Path (Codecademy)
								</a>{" "}
								- Jan 2022
							</li>
							<li>
								<a
									href="https://www.codecademy.com/profiles/tikkisean/certificates/d3f89367b558583e361640f778191345"
									rel="noreferrer"
									target="_blank"
								>
									Learn Java (Codecademy)
								</a>{" "}
								- Jan 2022
							</li>
							<li>
								<a
									href="https://www.coursera.org/account/accomplishments/specialization/certificate/6RN7CFLAW6XM"
									rel="noreferrer"
									target="_blank"
								>
									Python for Everybody Specialization (Coursera)
								</a>{" "}
								- Nov 2021
							</li>
						</ul>
					</div>
				</div>
			</div>
		</main>
	);
}
